export { default } from "./CarouselButton.jsx";
